import React from 'react'
import { useLocation } from 'react-router-dom';
import { useNavigate } from "react-router-dom";

import moment from "moment";
import useAuth from "../../hooks/useAuth";
import Logo from "../../../assets/logo.png";
import { Span } from "../../components/Typography";

import { LoadingButton } from "@mui/lab";
import {
    Box,
    Container,
    Divider,
    Grid,
    Icon,
    styled,
    Typography,
} from "@mui/material";
import _ from 'lodash';
import { tenantPublicPageUrl, tenantServicesPageUrl } from '../../utils/tenantApi';
const MainBox = styled(Box)(({ theme }) => ({
    "& .topHeader": {
        position: "fixed",
        width: "100%",
        backgroundColor: "#fff",
        zIndex: "999",
        boxShadow:
            "rgba(50, 50, 93, 0.25) 0px 6px 12px -2px, rgba(0, 0, 0, 0.3) 0px 3px 7px -3px",
        "& .logoContainer": {
            padding: "5px 0 2px 0",
            "& img": {
                width: "200px",
            },
        },
        "& .signInBtn": {
            color: "#3498db",
            fontSize: "1rem",
            fontWeight: "600",
        },
        "& .bodyTxt": {
            color: "#3498db",
            paddingRight: "0.3rem",
        },
    },
    "& .contentMain": {
        paddingTop: "8rem",
        "& .bookingTitle": {
            textAlign: "center",
            fontWeight: "bold",
            paddingBottom: "1rem",
            paddingTop: "1rem",
        },
        "& .coverImage": {
            width: "100%",
        },
        "& .tell-us": {},
        "& .subHeadings": {
            fontWeight: "bold",
            fontSize: "1.4rem",
            paddingTop: "1rem",
            paddingBottom: "1rem",
        },
    },
}));
const StyledItem = styled("div")(({ theme }) => ({
    display: "flex",
    alignItems: "center",
    minWidth: "fit-content",
    cursor: "pointer",
    "& a": {
        width: "100%",
        display: "flex",
        alignItems: "center",
        textDecoration: "none",
    },
    "& span": { marginRight: "10px", color: theme.palette.text.primary },
}));

const ZelleCheckout = () => {
    const token = localStorage.getItem('accessToken');
    const { logout } = useAuth();
    const location = useLocation();
    const navigate = useNavigate();
    const stateToPass = location.state;
    return (
        <MainBox >
            <Box className="topHeader">
                <Container maxWidth="lg">
                    <Box
                        display={"flex"}
                        alignItems="center"
                        justifyContent={"space-between"}
                    >
                        <Box className="logoContainer">
                            <a href={token ? '/dashboard/default' : tenantServicesPageUrl()}>
                                <img
                                    src={Logo}
                                    alt="logo"
                                    className="logoImg"
                                    style={{ cursor: "pointer" }}
                                />
                            </a>
                        </Box>
                        <Box display={"flex"} alignItems="center">
                            <Box
                                display={"flex"}
                                alignItems="center"
                                sx={{ marginLeft: "1rem" }}
                            >
                                <StyledItem
                                    onClick={() => {
                                        if (token) logout();
                                        navigate('/session/signin');
                                    }}
                                >
                                    <Icon>{token ? 'power_settings_new' : 'login'}</Icon>
                                    <Span>{token ? 'Logout' : 'Sign in'}</Span>
                                </StyledItem>
                            </Box>
                        </Box>
                    </Box>
                </Container>
            </Box>
            <div style={{ background: 'linear-gradient(45deg, white 46%, #1976d29e 50%)', display: 'flex', justifyContent: 'center',height:"100vh" }}>
                <Grid container sx={{ backgroundColor: 'white', width: '95%', position: 'relative',  px: "30px !important", boxShadow: '0 4px 8px 0 rgba(0, 0, 0, 0.2), 0 6px 20px 0 rgba(0, 0, 0, 0.19)', py: "25px !important", mt: "105px !important",height:'max-content',mb:'10px !important' }}>
                    <Grid item xs={12}>
                        <Box
                            sx={{
                                background: "#dddada1a",
                                padding: "3rem",
                                width: "100%",
                                border: "1px solid #dddada",
                                textAlign: "center",
                                "& a": {
                                    "&:hover": {
                                        textDecoration: "underline",
                                    },
                                },
                            }}
                        >
                            <Typography variant='h2' fontWeight={'bold'}>Checkout</Typography>
                            <Typography
                                variant="h4"
                                className="bookingTitle"
                                sx={{
                                    textTransform: "capitalize",
                                    fontSize: "1.75rem !important",
                                }}
                            >
                                Thank you. Your order has been received.
                            </Typography>
                            <Grid container spacing={4} sx={{ mt: '15px !important' }}>
                                <Grid item xs={12} lg={5}>
                                <Typography variant='h4' fontWeight={'bold'} textAlign={'left'}>Zelle Notice</Typography>
                                    <Box textAlign={'left'}>
                                        <p>Send <span>${stateToPass?.checkoutData?.todaysTotal
                      ? stateToPass?.checkoutData?.codesDiscount
                        ? (stateToPass?.checkoutData?.todaysTotal - stateToPass?.checkoutData?.codesDiscount)?.toFixed(2)
                        : stateToPass?.checkoutData?.todaysTotal?.toFixed(2)
                      : 0}</span> via <a style={{color: '#6d1fd4'}} href="https://zellepay.com/" target="_blank" rel="noreferrer">Zelle</a> or from your bank.</p>
                                        <p>Here are the Zelle details you should know for the transfer</p>
                                        <p>Zelle Name: <br/>Zelle Email: <strong>{stateToPass?.checkoutData?.values?.email || ''}</strong><br/>Zelle Phone: </p>
                                        <p>Please <strong>use your Order Number (available once you place order)</strong> as the payment reference.</p><p><strong>After paying, please come back here and place the order below</strong> so we can start processing your order.</p>
                                    </Box>
                                </Grid>
                                <Grid item xs={12} lg={7}>
                                <Typography variant='h4' fontWeight={'bold'} textAlign={'left'}>Order details</Typography>
                                <Box
                sx={{
                  width: "100%",
                  background: "white",
                  padding: "1rem",
                  paddingTop: "1rem",
                  paddingBottom: "1rem",
                  border: "1px solid #dddada",
                  marginTop: '10px'
                }}
              >
                <Typography
                  variant="h6"
                  style={{ paddingBottom: "0.2rem" }}
                  className="subHeadings"
                >
                  {stateToPass?.checkoutData?.values?.frequency === "once" && "One Time Cleaning Plan"}
                  {stateToPass?.checkoutData?.values?.frequency === "weekly" && "Weekly Cleaning Plan"}
                  {stateToPass?.checkoutData?.values?.frequency === "biweekly" && "Biweekly Cleaning Plan"}
                  {stateToPass?.checkoutData?.values?.frequency === "monthly" && "Monthly Cleaning Plan"}
                </Typography>
                <div
                  style={{ display: "flex", justifyContent: "space-between" }}
                >
                  {/* {frequency !== 'once' && (
                  <Typography variant="body1" style={{ fontSize: '1rem' }}>
                    6 Months
                  </Typography>
                )} */}
                  <Typography variant="body1" style={{ fontSize: "1rem" }}>
                    Date & Time:{" "}
                  </Typography>
                  <Typography variant="body1">
                    {stateToPass?.checkoutData?.values.start_date
                      ? moment(stateToPass?.checkoutData?.values.start_date).format("MMMM DD, YYYY")
                      : ""}{" "}
                    -{" "}
                    {stateToPass?.checkoutData?.availableTimes.find((z) => z.value === stateToPass?.checkoutData?.values?.start_time)
                      ?.label || ""}
                  </Typography>
                </div>
                <Divider sx={{ marginTop: "1rem", marginBottom: "1rem" }} />
                <Box
                  display={"flex"}
                  alignItems="center"
                  justifyContent={"space-between"}
                  paddingBottom="1rem"
                >
                  <Typography variant="body1" style={{ fontSize: "1rem" }}>
                    Per cleaning
                  </Typography>
                  <Typography variant="body1" style={{ fontSize: "1rem" }}>
                    $
                    {_.compact(stateToPass?.checkoutData?.selectedItems)
                      .map((item) => {
                        return parseFloat(item?.price).toFixed(2);
                      })
                      .reduce((accumulator, value) => {
                        return +accumulator + +value;
                      }, 0)}
                  </Typography>
                </Box>
                <Box
                  display={"flex"}
                  alignItems="center"
                  justifyContent={"space-between"}
                  paddingBottom="1rem"
                >
                  <Typography variant="body1" style={{ fontSize: "1rem" }}>
                    Discounts
                  </Typography>
                  <Typography variant="body1" style={{ fontSize: "1rem" }}>
                    $
                    {_.compact(stateToPass?.checkoutData?.selectedItems)
                      .map((item) => {
                        const percent =
                          (item?.discount_percent * +item?.price) / 100;
                        return percent;
                      })
                      .reduce((accumulator, value) => {
                        return +accumulator + +value;
                      }, 0)}
                  </Typography>
                </Box>
                <Box
                  display={"flex"}
                  alignItems="center"
                  justifyContent={"space-between"}
                  paddingBottom="1rem"
                >
                  <Typography variant="body1" style={{ fontSize: "1rem" }}>
                    Extras
                  </Typography>
                  <Typography variant="body1" style={{ fontSize: "1rem" }}>
                    $
                    {_.compact(stateToPass?.checkoutData?.selectedExtras)
                      .map((item) => {
                        const price = parseFloat(item?.price) * item?.quantity;
                        return price.toFixed(2);
                      })
                      .reduce((accumulator, value) => {
                        return +accumulator + +value;
                      }, 0)}
                  </Typography>
                </Box>
                {/* <Box
                  display={'flex'}
                  alignItems="center"
                  justifyContent={'space-between'}
                  paddingBottom="1rem"
                >
                  <Typography variant="body1" style={{ fontSize: '1rem' }}>
                    Tax Rate
                  </Typography>
                  <Typography variant="body1" style={{ fontSize: '1rem' }}>
                    {bookingData?.tax?.[0]?.tax_rate}%
                  </Typography>
                </Box> */}
                <Box
                  display={"flex"}
                  alignItems="center"
                  justifyContent={"space-between"}
                  paddingBottom="1rem"
                >
                  <Typography variant="body1" style={{ fontSize: "1rem" }}>
                    Estimated Tax
                  </Typography>
                  <Typography variant="body1" style={{ fontSize: "1rem" }}>
                    ${stateToPass?.checkoutData?.estimatedTax ? stateToPass?.checkoutData?.estimatedTax?.toFixed(2) : 0}
                  </Typography>
                </Box>
                {stateToPass?.checkoutData?.promoDiscount && (
                  <Box
                    display={"flex"}
                    alignItems="center"
                    justifyContent={"space-between"}
                    paddingBottom="1rem"
                  >
                    <Typography variant="body1" style={{ fontSize: "1rem" }}>
                      Promo Code Discount
                    </Typography>
                    <Typography variant="body1" style={{ fontSize: "1rem" }}>
                      ${stateToPass?.checkoutData?.promoDiscount ? stateToPass?.checkoutData?.promoDiscount?.toFixed(2) : 0}
                    </Typography>
                  </Box>
                )}
                {stateToPass?.checkoutData?.giftCardDiscount && (
                  <Box
                    display={"flex"}
                    alignItems="center"
                    justifyContent={"space-between"}
                    paddingBottom="1rem"
                  >
                    <Typography variant="body1" style={{ fontSize: "1rem" }}>
                      Gift Card Discount
                    </Typography>
                    <Typography variant="body1" style={{ fontSize: "1rem" }}>
                      ${stateToPass?.checkoutData?.giftCardDiscount ? stateToPass?.checkoutData?.giftCardDiscount?.toFixed(2) : 0}
                    </Typography>
                  </Box>
                )}
                <Divider sx={{ marginTop: "1rem", marginBottom: "1rem" }} />
                <Box
                  display={"flex"}
                  alignItems="center"
                  justifyContent={"space-between"}
                >
                  <Typography
                    variant="h6"
                    className="subHeadings"
                    style={{ paddingTop: "unset" }}
                  >
                    TODAY'S TOTAL
                  </Typography>
                  <Typography variant="body1" style={{ fontSize: "1rem" }}>
                    $
                    {stateToPass?.checkoutData?.todaysTotal
                      ? stateToPass?.checkoutData?.codesDiscount
                        ? (stateToPass?.checkoutData?.todaysTotal - stateToPass?.checkoutData?.codesDiscount)?.toFixed(2)
                        : stateToPass?.checkoutData?.todaysTotal?.toFixed(2)
                      : 0}
                  </Typography>
                </Box>
              </Box>
                                </Grid>
                            </Grid>
                            <Box
                                display={"flex"}
                                alignItems="center"
                                justifyContent={"end"}
                                sx={{ mb: 2, mt: 3 }}
                            >
                            <LoadingButton
                                    color="primary"
                                    variant="contained"
                                    onClick={() => navigate(tenantPublicPageUrl('confirm-booking'), { state: stateToPass })}
                                >
                                    See booking details
                                </LoadingButton>

                            </Box>
                        </Box>
                    </Grid>
                </Grid>
            </div>

        </MainBox>

    )
}

export default ZelleCheckout;
